import AddressEdit from './AddressEdit.vue';
import axios from 'axios';
// import { BaseAddressAPI as BaseDataAPI } from 'govmo-common/src/api';

export const addressMixin = {
  components: { AddressEdit },
  methods: {
    async addressFetch(
      type,
      { keyword, region /*provinceCode, cityCode, areaCode, cnpCode*/ } = {}
    ) {
      const baseUrl = process.env.VUE_APP_GOV_MO_DOMAIN_ADDRESS;
      if (type === 'area') {
        const { data } = await axios.get(`${baseUrl}/cadastre/v1.0/areas`);
        return { data: (data && data.data) || [] };
      }
      if (type === 'region') {
        const { data } = await axios.get(`${baseUrl}/cadastre/v1.0/regions`);
        return { data: (data && data.data) || [] };
      }
      if (type === 'country') {
        const { data } = await axios.get(`${baseUrl}/cadastre/v1.0/countries`);
        return { data: (data && data.data) || [] };
      }

      if (type === 'address') {
        if (!keyword) {
          return { data: [] };
        }
        let areaQuery = `area=${region || ''}`;
        if (region === 'MTC') {
          areaQuery = `area=M&area=T&area=C`;
        }
        const { data } = await axios.get(
          `${baseUrl}/cadastre/v1.0/address/${keyword || ''}?key=${
            keyword || ''
          }&${areaQuery || ''}`
        );
        return { data: (data && data.data) || [] };
      }

      // // 中國內地地址 - 省
      // if (type === 'province') {
      //   const res = await BaseDataAPI.getAddress({
      //     cityCode: 0,
      //     areaCode: 0,
      //     townCode: 0,
      //     type: 'PROVINCE',
      //   });
      //   return { data: res };
      // }

      // // 中國內地地址 - 城市
      // if (type === 'city') {
      //   const res = await BaseDataAPI.getAddress({
      //     provinceCode,
      //     areaCode: 0,
      //     townCode: 0,
      //     type: 'CITY',
      //   });
      //   return { data: res };
      // }

      // // 中國內地地址 - 區鄉
      // if (type === 'district') {
      //   const res = await BaseDataAPI.getAddress({
      //     provinceCode,
      //     cityCode,
      //     townCode: 0,
      //     type: 'AREA',
      //   });
      //   return { data: res };
      // }

      // // 中國內地地址 - 街道
      // if (type === 'town') {
      //   const res = await BaseDataAPI.getAddress({
      //     provinceCode,
      //     cityCode,
      //     areaCode,
      //     type: 'TOWN',
      //   });
      //   return { data: res };
      // }

      // // 中國內地地址 - 街道
      // if (type === 'defaultCode') {
      //   const res = await BaseDataAPI.searchAddress(cnpCode);
      //   return { data: res };
      // }

      return {
        data: [],
      };
    },
  },
};
